import { CorpsDocument } from '~/apollo/gql/graphql'
import type { CorpsOption } from '~/types/form'

export const useCorpsOptions = () => {
  const { result, loading, load } = useLazyQuery(CorpsDocument)

  const options: ComputedRef<CorpsOption[]> = computed(() => {
    if (!result.value) return []

    return result.value.corps.map(corps => ({
      label: corps.name,
      value: corps.id,
      abbr: corps.abbr,
      abbr_fem: corps.abbr_fem
  }))
  })

  return { load, loading, options }
}
